export const COPPER_GOLD_INTRO =
  'Copper/gold ratio = growth optimism vs fear. Correlation of weekly ratio changes with 10Y yield changes shows whether rates follow the real economy.';

export const REGIME_ROWS = [
  {
    id: 'growth_linked',
    range: '≥ +0.35',
    label: 'Growth-linked',
    emoji: '🟢',
    tooltip: 'Rates moving with growth expectations.',
  },
  {
    id: 'mixed',
    range: '−0.20 to +0.35',
    label: 'Mixed',
    emoji: '🟡',
    tooltip: 'Partial or transitional link.',
  },
  {
    id: 'divergence',
    range: '≤ −0.20',
    label: 'Divergence',
    emoji: '🔴',
    tooltip: 'Rates moving without growth support — fiscal, inflation, term premium.',
  },
];

const GROWTH = 0.35;
const DIV = -0.2;

export function fmtSignedCorr(value) {
  if (value == null || Number.isNaN(value)) return '—';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}`;
}

export function regime(c) {
  if (c == null || Number.isNaN(c)) {
    return { id: 'unknown', label: '—', emoji: '', cssClass: 'neutral' };
  }
  if (c >= GROWTH) return { ...REGIME_ROWS[0], cssClass: 'growth' };
  if (c <= DIV) return { ...REGIME_ROWS[2], cssClass: 'divergence' };
  return { ...REGIME_ROWS[1], cssClass: 'mixed' };
}

export function situationAtPoint(c13, c26, c52) {
  const r26 = regime(c26);
  const headline =
    r26.id === 'growth_linked'
      ? 'Growth-linked — yields with copper/gold.'
      : r26.id === 'divergence'
        ? 'Divergence — yields detached from growth.'
        : r26.id === 'mixed'
          ? 'Mixed link between ratio and yields.'
          : 'Regime unclear.';
  const detail = `13w ${fmtSignedCorr(c13)}; 26w ${fmtSignedCorr(c26)}; 52w ${fmtSignedCorr(c52)}. ${r26.tooltip || ''}`;
  return { headline, detail, r26, primaryCss: r26.cssClass };
}

export function pickCorr(bars, time) {
  return bars?.find((b) => b.time === time)?.value ?? null;
}
